import { applySpec, prop, compose, defaultTo } from 'ramda';

const amountDefaultTo1 = compose(
	defaultTo(1),
	prop('amount')
);

export default applySpec({
	id: prop('ID'),
	name: prop('NAME'),
	price: prop('PRICE'),
	priceFormated: prop('PRICE_FORMATED'),
	amount: amountDefaultTo1,
	min: amountDefaultTo1,
	isDeletable: () => false,
});
